import { useState } from "react";
import antSvg from "../../assets/animals/ant.svg";
import beeSvg from "../../assets/animals/bee.svg";
import botSvg from "../../assets/animals/bot.svg";
import dolphinSvg from "../../assets/animals/dolphin.svg";
import eagleSvg from "../../assets/animals/eagle.svg";
import foxSvg from "../../assets/animals/fox.svg";
import leopardSvg from "../../assets/animals/leopard.svg";
import monkeySvg from "../../assets/animals/monkey.svg";
import penguinSvg from "../../assets/animals/penguin.svg";
import rabbitSvg from "../../assets/animals/rabbit.svg";
import squirrelSvg from "../../assets/animals/squirrel.svg";

/** v3 ANIMATED_ANIMALS — one scout per thinking phase. */
const ANIMALS = [
  { name: "Eagle AI", src: eagleSvg, text: "Eagle AI is spotting top-tier talent from above..." },
  { name: "Clever Fox", src: foxSvg, text: "Clever Fox is scouting stealth candidates and portfolios..." },
  { name: "Busy Bee AI", src: beeSvg, text: "Busy Bee AI is cross-pollinating talent pools..." },
  { name: "Leopard Scout", src: leopardSvg, text: "Fast Leopard AI is sprinting through matching databases..." },
  { name: "Dolphin AI", src: dolphinSvg, text: "Dolphin AI is diving deep into candidate analytics..." },
  { name: "Speedy Rabbit", src: rabbitSvg, text: "Speedy Rabbit is hopping through profile summaries..." },
  { name: "Chill Penguin", src: penguinSvg, text: "Chill Penguin is slide-ranking interview rubrics..." },
  { name: "Smart Squirrel", src: squirrelSvg, text: "Smart Squirrel is gathering the best portfolio gems..." },
  { name: "Monkey AI", src: monkeySvg, text: "Monkey AI is swinging through skill trees and endorsements..." },
  { name: "Ant Scout", src: antSvg, text: "Ant Scout is indexing and structuring talent data..." },
  { name: "Smart Bot", src: botSvg, text: "Smart Scout Bot is calibrating company culture DNA..." },
];

const pickAnimal = () => ANIMALS[Math.floor(Math.random() * ANIMALS.length)];

interface ScoutingIndicatorProps {
  /** Live tool label from the socket; falls back to the animal's own line. */
  label?: string;
}

/**
 * Centered free-floating animal + one status line while Smart Scout works
 * (v3: no background, no name title, no loading bar).
 */
export function ScoutingIndicator({ label }: ScoutingIndicatorProps) {
  const [animal] = useState(pickAnimal);

  return (
    <div
      role="status"
      aria-live="polite"
      className="my-6 flex flex-col items-center justify-center py-8 text-center motion-safe:animate-fade-in"
    >
      <div className="relative flex size-36 items-center justify-center">
        <img src={animal.src} alt={animal.name} className="size-full object-contain" />
      </div>
      <p className="mt-3.5 max-w-md text-sm font-medium text-ink-muted">
        {label || animal.text}
      </p>
    </div>
  );
}
